<template>
  <q-page>
    <div v-if="$apollo.loading">Loading...</div>
          <h4 class="text-center">Enquiries</h4>
          <q-table
            hide-bottom
            :pagination="{rowsPerPage: 0}"
            :columns="columns"
            :data="enquiries" 
            row-key="skuId"
          >
            <template v-slot:body-cell-id="props">
              <td props="props">
                <q-btn dense outline color="primary" label="View" :to="`/admin/sales/enquiry/${props.row.id}`"/>
              </td>
            </template>
        
            <!--  <template v-slot:body-cell-actions="props">
              <td props="props">
                <div class="row">
                  <q-btn size="md" flat dense color="primary" icon="delete" />
                </div>
              </td>
            </template> -->
          </q-table> 
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminAccounts',
  apollo: {
    enquiries: {
      query: gql`
        query {
          enquiries {
            id
            firstName
            lastName
            message
            email
            phone
            type
            timezone
            utm_source
            utm_medium
            utm_campaign
            territory
            eid
            notes
          }
        }
      `,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
  },
  data () {
    return {
      filter: '',
      columns: [
        { name: 'id', align: 'left', required: true, label: '', field: 'id', sortable: true },
        { name: 'firstName', align: 'left', required: true, label: 'Name', field: 'firstName', sortable: true },
        { name: 'lastName', align: 'left', required: true, label: 'Lastname', field: 'lastName', sortable: true },
        { name: 'message', align: 'left', required: true, label: 'Message', field: 'message', sortable: true },
        { name: 'email', align: 'left', required: true, label: 'Email', field: 'email', sortable: true },
        { name: 'phone', align: 'left', required: true, label: 'Phone Number', field: 'phone', sortable: true },        
        { name: 'territory', align: 'left', required: true, label: 'Territory', field: 'territory', sortable: true },
      ],
      pagination: {
        rowsPerPage: 100
      }
    }
  }
}
</script>
